<template>
<div>
    <Layout v-if="cstore.getCruiseBook.ok" :slotInfoLinkRooms="false" :CruiseBook="cstore.getCruiseBook.resolve">
        <template>
        </template>
        <template #after>
            <Preview :maybook="maybook" :dobook="dobook" />
            <BookCabins v-if="!dobook.wait" :ForBook="true" :maybook="maybook" @book="action_book" />
        </template>
    </Layout>

    <div v-if="cstore.getCruiseBook.wait" class="CruisePage__ifloader"><Loader class="CruisePage__loader" /></div>

    <div v-if="cstore.getCruiseBook.reject">! не удалось</div>
</div>
</template>


<script setup>
import {unref, ref, watch, computed, onMounted, reactive, onUnmounted } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import Layout from '@/comp/CruiseHead/Layout.vue'

import useCruiseStore from '@/cstore.js'
import useTouristStore from '@/tourist/tourist-store.js'
import useCabinsStore from '@/bookCabins.js'

import Loader from '@/comp/Loader/Loader.vue'
import BookCabins from '@/comp/BookCabins/BookCabins.vue'
import Preview from '@/comp/FaseBook/Preview.vue'
import {beforeBookCheck} from '@/comp/useOrder.js'
import {LOCALSTOR_BOOK_KEY, save_localStorage} from '@/localStor.js'
import {book, book_check, nc_eq, CRUISE_BOOK_MAX} from '@/actions.js'
import useTimer from '@/comp/timer.js'

const cstore = useCruiseStore()
const tstore = useTouristStore()
const bookCabins = useCabinsStore()
const route = useRoute()
const router = useRouter()
const {start_timer, stop_timer, attempt_timer, tick_timer, leave_min, is} = useTimer()

const maybook = reactive( {
    wait: true,
    may: false,
    errors: [],
    calc_prices: null,
    message: '',
    travelers: {}
})

const dobook = reactive({
    wait: false,
    error: '',
    bookData: {},
    ts: '',
})



const set_maybook = () => {
    //useCruiseOrderCheck( tstore.pers, cstore.getCabins, tstore.customer ) 
    const {errs, travelers} = beforeBookCheck( cstore, tstore, bookCabins )
//console.log('set_maybook bookData', bookData)
    let ret = true
    if (errs.length) {
        maybook.wait = false
        maybook.may = false;
        maybook.errors = [{text: 'Не все поля заполнены верно'}]
        ret = Promise.reject(true)
    } else {
        maybook.travelers = travelers
    }
    return ret
}

const start_book_check = () => {
    const {cruiseIdFull} = bookCabins.bookBox
    const key = cstore.getCruiseBook.id
    const {travelers} = maybook
    dobook.bookData = { cruiseIdFull, key, ...travelers }
//console.log('start_book_check',  dobook) 
    book_check( dobook.bookData ).then( 
        resolve => proc_book_check( {resolve } ),
        reject =>  proc_book_check( {reject} )
    )
}
const proc_book_check = ({resolve, reject}) => {
    if (resolve) {
        maybook.may = true
        maybook.calc_prices = resolve.calc_prices
        maybook.message = resolve.message
    } else { // на серве
        maybook.may = false
        maybook.errors.push( { text: reject.toString() } )
if (false) {// верстка: выполняется бронирования
    dobook.wait = true 
    dobook.ts = (new Date()).toISOString()
    start_timer(CRUISE_BOOK_MAX)
}
    }
    maybook.wait = false
}

onUnmounted( stop_timer )
const action_book = () => {
    if (dobook.wait) {
        return;
    }
    dobook.wait = true 
    dobook.ts = (new Date()).toISOString()
    start_timer(CRUISE_BOOK_MAX)

    book( dobook.bookData ).then( 
        resolve => proc_book( {resolve } ),
        reject =>  proc_book( {reject} )
    )
}
const proc_book = ({resolve, reject}) => {
    dobook.wait = false

    let message, claim_id, claim_num, calc_prices
    if (resolve) {
        message = resolve.message
        claim_id = resolve.claim_id
        claim_num = resolve.claim_num
        calc_prices = resolve.calc_prices
    } else {
        message = maybook.message
        claim_id = ''
        claim_num = ''
        calc_prices = maybook.calc_prices
    }
    let status = {
        ok: resolve ? true : false,
        ts: dobook.ts,
    }

    let { bookData } = dobook
    const { _ : sid } = nc_eq()
    const locob = { sid, message, claim_id, claim_num, bookData, calc_prices, status }
    save_localStorage( LOCALSTOR_BOOK_KEY, locob)

    bookCabins.clean()
    tstore.clean()

    router.push({name: 'BookOk', query: {sid} })
}



watch( 
    [   
        () => route.query.cruiseIdFull,
    ],
    (   [cruiseIdFull], 
        [old_cruiseIdFull]
    ) => {
        if (cruiseIdFull !== old_cruiseIdFull) {
            cstore.loadCruiseBook( { cruiseIdFull } ).then( set_maybook ).then( start_book_check )
        }
    },
    { immediate: true }
)
</script>
